export default __webpack_public_path__ + "static/media/postgresql.a8f0d5e2.png";